"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@mui/styles");
var _material = require("@mui/material");
var _elements = require("./elements");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var DialogActions = function DialogActions(_ref) {
  var children = _ref.children,
    className = _ref.className;
  var theme = (0, _styles.useTheme)();
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Divider, null), /*#__PURE__*/_react["default"].createElement(_elements.StyledMuiActions, {
    className: className,
    theme: theme
  }, children));
};
DialogActions.propTypes = {
  children: _propTypes["default"].node.isRequired,
  className: _propTypes["default"].string
};
DialogActions.defaultProps = {
  className: ''
};
var _default = exports["default"] = DialogActions;